// extracted by mini-css-extract-plugin
export default {"fallbackWrapper":"Fallback_fallbackWrapper__UKBJC","fallbackSvg":"Fallback_fallbackSvg__IntUI"};